var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClientOnly',[_c('GmapMap',{staticClass:"google-map w-full h-full bg-[#e5e3df]",attrs:{"center":_vm.center,"zoom":_vm.zoom,"options":_vm.options,"map-type-id":"terrain"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }